<template>
  <no-ssr>
    <a-scene
      embedded
      vr-mode-ui="enabled: false"
      device-orientation-permission-ui="enabled:false"
      renderer="color-management:true; physically-correct-lights:true;"
    >
      <a-entity
        :gltf-model="this.model"
        :scale="this.scale"
        :position="this.position"
        animation="property: rotation; to: 0 360 0; loop: true; dur: 20000; easing: linear;"
      />

      <!-- TODO video
    <a-box
      video
      visible="false"
      color="black"
      class="clickable"
      height="10"
      width="16"
      depth="0"
      position="10, 6, -11"
      rotation="0 -10 0"
    ></a-box> -->

      <!-- camera -->
      <a-camera look-controls-enabled="false" position="0 1 5" />

      <!-- lighting -->
      <a-entity
        light="type: directional; color: #ffffff; intensity: 2; castShadow: true"
        position="1, 1.75, 1"
      />
      <a-entity
        light="type: directional; color: #ffffff; intensity: 2; castShadow: true"
        position="0, 0, 1"
      />
      <a-entity
        light="type: directional; color: #ffffff; intensity: 2; castShadow: true"
        position="-1, .5, -2"
      />
      <a-light type="ambient" intensity="1" />
    </a-scene>
  </no-ssr>
</template>
<script>
export default {
  props: {
    scale: {
      type: String,
      default () {
        return '1 1 1'
      }
    },
    position: {
      type: String,
      default () {
        return '0 0 0'
      }
    },
    model: {
      type: String,
      default () {
        return
        ;('gltf/drop_logo.glb')
      }
    }
  }
}
</script>
